var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldShip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.22 16.52C20.51 19.72 18 22 14.38 22H9.62C6 22 3.49 19.72 2.78 16.52l-.41-1.86c-.2-.91.34-1.94 1.21-2.29L5 11.8l5.51-2.21c.48-.19.99-.29 1.49-.29s1.01.1 1.49.29L19 11.8l1.42.57c.87.35 1.41 1.38 1.21 2.29l-.41 1.86z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9.44c0 .35-.36.6-.69.46l-4.27-1.71a5.607 5.607 0 0 0-4.09.01L5.69 9.91A.499.499 0 0 1 5 9.45V8c0-1.65 1.35-3 3-3h8c1.65 0 3 1.35 3 3v1.44zM9.5 5V3c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v2h-5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldShip);
export default __webpack_public_path__ + "static/media/vuesax-bold-ship.a3992b6e038b74cf01ec884c223e7818.svg";
export { ForwardRef as ReactComponent };